<template>
  <div 
    v-if="isLoaded"
    class="sm-customer"
  >
    <customer-top />
    <customer-main />
  </div>
  <sm-spinner
    v-else
    :show="true"
  />
</template>

<script>
import Upper from '@/views/admin/pages/customer/Upper.vue';
import Main from '@/views/admin/pages/customer/Main.vue';
import Spinner from '@/components/Spinner'
import store from '@/store';
import { CheckHigherRole } from '@/utils/roles';

export default {
  name: 'account',
  components: {
    'customer-top': Upper,
    'customer-main': Main,
    'sm-spinner': Spinner
  },
  data() {
    return {
      isLoaded: true
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      if(!to.params.id){
        next({name: 'admin-customers'});
        return;
      }
      const customer = await store.dispatch('customers/getCustomer',to.params.id)
      if (!customer){
        next({name: 'admin-customers'});
        return;
      }

      if(!store.state.account.userAccount.role){
        await store.dispatch('account/userData');
      }

      if (!CheckHigherRole(store.state.account.userAccount.role, store.state.customers.currentCustomer.role)){
          next({name: 'admin-customers'});
          return;
      }
      
      next();
    } catch (error) {
      next({name: 'admin-customers'});      
    }
  },
}
</script>

<style lang="scss">
  
</style>
